export enum StorageKeyEnum {
  AccessToken = 'AccessToken',
  RefreshToken = 'RefreshToken',

}
